import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditContestData } from "./EditContestData";
import { CircularProgress } from "@mui/material";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
export var ContestTabs = function () {
    var aliasRenderer = useAliasRenderer();
    var record = useRecordContext();
    if (!record) {
        return _jsx(CircularProgress, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: aliasRenderer(record), subtitle: "contestScreen.common.subtitle" }), _jsx(TabbedShowLayout, { children: _jsx(TabbedShowLayout.Tab, { label: "Data", children: _jsx(EditContestData, {}) }) })] }));
};
